import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { compose } from 'react-apollo'
import { Link, withRouter } from 'react-router-dom'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { connect } from 'react-redux'

import { smallerThan } from 'utils/media'
import withNav from 'containers/withNav'
import withSiteMeta from 'containers/withSiteMeta'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

import Logo from 'ui/components/generic/Logo'
import LogoSmall from 'ui/components/generic/LogoSmall'
import IconSearch from 'ui/components/generic/IconSearch'
import MenuIcon from 'ui/components/generic/MenuIcon'

import Nav from './Nav'
import SubMenu from './SubMenu'
import Overlay from './Overlay/index'
import Search from './Search'
import LanguageSelector from './LanguageSelector'
import Some from './Some'

const NavItemPropType = PropTypes.shape({
  id: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string
})

class Navigation extends Component {
  static propTypes = {
    mainNav: PropTypes.arrayOf(NavItemPropType).isRequired
  }

  static defaultProps = {
    mainNav: [],
  }

  state = {
    hoverItem: undefined,
    hoverSubMenu: undefined,
    languageSelectorVisible: false,
    overlayVisible: false,
    scrolledDown: false,
    searchVisible: false,
    subMenu: undefined
  }

  componentDidMount() {
    window.addEventListener('scroll', this.checkScrollPosition)
    this.checkScrollPosition()
  }

  componentDidUpdate(prevProps) {
    const { overlayVisible } = this.state

    if (overlayVisible && prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ overlayVisible: false })
    }

    if (prevProps.offset !== this.props.offset) {
      this.checkScrollPosition()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkScrollPosition)
  }

  closeOverlay = () => this.setState({ overlayVisible: false })

  checkScrollPosition = () => {
    const { scrolledDown } = this.state
    const { offset } = this.props
    const scrollPosition = typeof (document.scrollingElement) !== 'undefined' ? document.scrollingElement.scrollTop : window.pageYOffset


    if (scrollPosition >= 0) {
      if (scrollPosition >= offset && !scrolledDown) {
        this.setState({ scrolledDown: true })
      } else if (scrollPosition < offset && scrolledDown) {
        this.setState({ scrolledDown: false })
      }
    }
  }

  handleMouseEnterItem = (item) => {
    if (item.childItems.length > 0) {
      clearTimeout(this.hoverTimeout)

      // First set the sub menu
      this.setState({
        subMenu: item.childItems
      })

      // Postpone hover state to let sub menu
      // mount first and let transition animation kick in
      this.hoverTimeout = setTimeout(() => this.setState({
        hoverItem: true
      }), 350)
    }
  }

  handleMouseLeaveItem = () => {
    clearTimeout(this.hoverTimeout)

    this.hoverTimeout = setTimeout(() =>
      this.setState({
        hoverItem: false
      }), 500)
  }

  handleMouseEnterSubMenu = () => {
    this.setState({ hoverSubMenu: true })
  }

  handleMouseLeaveSubMenu = () => {
    this.hoverTimeout = setTimeout(() =>
      this.setState({
        hoverSubMenu: false
      }), 500)
  }

  handleClickSubMenu = () => {
    clearTimeout(this.hoverTimeout)

    this.setState({
      hoverSubMenu: false,
      searchVisible: false
    })
  }

  closeSearch = () => {
    this.setState({ searchVisible: false })
    if (document.body.classList.contains('scroll-lock')) {
      document.body.classList.remove('scroll-lock')
    }
  }

  toggleLanguageSelector = () => {
    this.setState({
      languageSelectorVisible: !this.state.languageSelectorVisible,
      overlayVisible: false,
      searchVisible: false
    })

    if (!this.state.languageSelectorVisible) {
      document.body.classList.add('scroll-lock')
    } else {
      document.body.classList.remove('scroll-lock')
    }
  }

  toggleSearch = () => {
    this.setState({
      languageSelectorVisible: false,
      overlayVisible: false,
      searchVisible: !this.state.searchVisible
    })
    if (!this.state.searchVisible) { }
    if (!this.state.searchVisible) {
      document.body.classList.add('scroll-lock')
    } else {
      document.body.classList.remove('scroll-lock')
    }
  }

  render() {
    const {
      mainNav,
      breakpoint,
      siteMeta
    } = this.props

    const {
      hoverItem,
      hoverSubMenu,
      languageSelectorVisible,
      overlayVisible,
      scrolledDown,
      searchVisible,
      subMenu
    } = this.state

    const phone = smallerThan(breakpoint, 'xl')
    const subMenuVisible = hoverItem || hoverSubMenu

    //Changing solid variable to always true in order to have white background all the time
    //const solid = scrolledDown || overlayVisible || subMenuVisible || searchVisible || languageSelectorVisible
    const solid = true

    const language = siteMeta.languages && siteMeta.languages.find(l => l.key === siteMeta.locale)

    return (
      <div>
        <Wrapper>
          {phone &&
            <Overlay visible={overlayVisible} />
          }

          <SubMenu
            visible={subMenuVisible}
            items={subMenu}
            onMouseEnter={!languageSelectorVisible ? this.handleMouseEnterSubMenu : undefined}
            onMouseLeave={!languageSelectorVisible ? this.handleMouseLeaveSubMenu : undefined}
            onClickLink={this.handleClickSubMenu}
          />

          <TopBar
            solid={solid}
          >
            <Container fluid>
              <Row alignItems="center">
                <LogoCol
                  xs={4}
                  sm={4}
                  lg={2}
                  onClick={() => this.closeSearch()}
                >
                  <Link
                    to={`/${siteMeta.locale === siteMeta.defaultLanguage ? '' : siteMeta.locale}`}
                    onClick={this.closeOverlay}
                  >
                    <Logo color={solid ? theme.colors.primary : '#fff'} />
                    <LogoSmall color={solid ? theme.colors.primary : '#fff'} />
                  </Link>
                </LogoCol>

                <MenuIconCol
                  xs={4}
                  sm={4}
                  lg={8}
                >
                  <MenuIcon
                    toggle={() => this.setState(state => ({ overlayVisible: !state.overlayVisible }))}
                    open={overlayVisible}
                    color={solid ? theme.colors.primary : '#fff'}
                  />
                </MenuIconCol>
                <NavCol
                  xs={8}
                  sm={8}
                  md={7}
                >
                  <Nav
                    locale={siteMeta.locale}
                    items={mainNav}
                    inverted={solid}
                    onItemMouseEnter={this.handleMouseEnterItem}
                    onItemMouseLeave={this.handleMouseLeaveItem}
                    onClickLink={this.closeSearch}
                    solid={solid}
                  />
                </NavCol>
                <SomeCol
                  lg={2}
                >
                  <Some></Some>
                </SomeCol>
                <SearchCol
                  xs={3}
                  sm={3}
                  lg={1}
                >

                  <SearchButton onClick={this.toggleSearch}>
                    <IconSearch
                      fillColor={searchVisible ? theme.colors.primary : '#f0f0f0'}
                      strokeColor={searchVisible ? '#f0f0f0' : theme.colors.primary}
                    />
                  </SearchButton>

                  {language && (
                    <LanguageSelectTrigger
                      onClick={this.toggleLanguageSelector}
                      languageSelectorVisible={languageSelectorVisible}
                    >
                      {language.flag_icon !== 'true' ?
                        (<span>{language.key}</span>)
                        :
                        (<Flag image={language.flag_icon} />)
                      }
                    </LanguageSelectTrigger>
                  )}

                </SearchCol>
              </Row>
            </Container>
          </TopBar>
        </Wrapper>

        <Search visible={searchVisible} />
        <LanguageSelector
          visible={languageSelectorVisible}
          languages={siteMeta.languages}
          defaultLanguage={siteMeta.defaultLanguage}
        />
      </div>
    );
  }
}

export default compose(
  withRouter,
  withNav('MAIN_NAV', 'mainNav'),
  withSiteMeta(),
  connect(state => ({ breakpoint: state.media.breakpoint, offset: state.navigationOffset }))
)(Navigation)

// Styles
const { colors, navHeight } = theme

const LogoCol = styled(Col)`
  display: flex;

  svg {

    &:first-child {
      display: none;

      ${media.md`
        display: block;
      `}
    }

    &:last-child {
      ${media.md`
        display: none;
      `}
    }
  }
`

const MenuIconCol = styled(Col)`
  display: flex;
  justify-content: center;

  ${media.xl`
    display: none;
  `}
`

const NavCol = styled(Col)`
  display: none;
  align-items: center;
  justify-content: flex-start;
  padding-right: 0 !important;
  padding-left: 0 !important;

  ${media.xl`
    display: flex;
    height: 100%;
  `}
`

const SearchCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding: 0;

  ${media.xs`
    padding-left: 0;
  `}
`
const SomeCol = styled(Col)`
display: none;
justify-content: center;
padding: 0;
  ${media.xl`
    display: flex;
  `}
`

const Button = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`

const SearchButton = styled(Button)``

const LanguageSelectTrigger = styled(Button)`
  width: 35px;
  height: 35px;
  background: ${props => props.languageSelectorVisible ? colors.primary : '#f0f0f0'};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
  transition: background-color 0.8s ${easing.easeOutCubic};

  span {
    text-transform: uppercase;
    font-size: 0.75rem;
    color: ${props => props.languageSelectorVisible ? 'white' : 'black'};
  }
`

const Flag = styled.div`
  width: 25px;
  height: 25px;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
  border-radius: 100%;
`

const TopBar = styled.div`
  position: relative;
  height: ${navHeight}px;
  background-color: rgba(255,255,255,${props => props.solid ? 1 : 0});
  color: ${props => props.solid ? colors.tones.darker : '#fff'};
  z-index: 2;
  transition: all 800ms ${easing.easeOutCubic};
  -webkit-box-shadow: 0px -2px 14px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px -2px 14px 0px rgba(0,0,0,0.75);
  box-shadow: 0px -2px 14px 0px rgba(0,0,0,0.75);

  &:hover {
    transition: all 200ms ${easing.easeOutCubic};
  }

  /** Make container, row fill height **/
  > div, > div > div {
    height: 100%;
  }

  /** Make container and columns transition **/
  > div, div > div > div {
    transition: all 800ms ${easing.easeOutCubic};
  }
`

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 20;
`



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/index.js